import { Square } from 'lucide-react'

import { HeroGradient, heroCardClass, heroLabelClass } from './hero-gradient'

// Cascading down and to the right, back-to-front — the newest reminder reads as
// the one on top.
const REMINDERS = [
  { label: 'Submit your Ramp expenses', indent: 'left-0 right-[42px] top-0 opacity-50' },
  { label: 'Respond to Jack in #recruiting', indent: 'left-[21px] right-[21px] top-8 opacity-90' },
  { label: 'Send top candidates to Jane', indent: 'left-[42px] right-0 top-16' },
]

/** Step 3: example reminders stacked like a freshly captured list. */
export function HeroReminders() {
  return (
    <HeroGradient>
      <div className="relative h-[119px] w-full">
        {REMINDERS.map(({ label, indent }) => (
          <div
            key={label}
            className={`${heroCardClass} absolute flex items-center gap-2 px-3 py-2 shadow-[0_2px_4px_rgba(0,0,0,0.08)] ${indent}`}
          >
            <Square className="text-black-9 size-4 shrink-0" strokeWidth={1.5} />
            <p className={`${heroLabelClass} truncate`}>{label}</p>
          </div>
        ))}
      </div>
    </HeroGradient>
  )
}
